import {
  ApplicationConditionalContext,
  useApplicationConditionalContext,
} from './useApplicationConditionalContext';
import {
  ConditionalWrapper,
  ConditionalWrapperProps,
} from './ConditionalWrapper';

export type ApplicationConditionalWrapperProps = Omit<
  ConditionalWrapperProps<ApplicationConditionalContext>,
  'context'
>;

export const ApplicationConditionalWrapper: React.FC<
  ApplicationConditionalWrapperProps
> = (props) => {
  const context = useApplicationConditionalContext();

  return <ConditionalWrapper context={context} {...props} />;
};
